import { getSchoolAssetUrl, normalizeSchoolAssetPath } from './api';

export function assetCacheToken(path, school, extraKey = '') {
  const m = String(path || '').match(/_(\d{10,})\./);
  if (m) return m[1];
  if (school?.updated_at) return String(new Date(school.updated_at).getTime());
  return extraKey || '';
}

/** Full URL for a school asset path with optional cache-bust query. */
export function schoolAssetDisplayUrl(path, schoolId, cacheKey = '') {
  const canonical = normalizeSchoolAssetPath(path, schoolId);
  if (!canonical) return null;
  const base = getSchoolAssetUrl(canonical, schoolId);
  if (!base) return null;
  const token = cacheKey || assetCacheToken(path);
  return token ? `${base}?v=${encodeURIComponent(token)}` : base;
}

function pathKind(p) {
  const s = String(p || '').toLowerCase();
  if (!s) return 'none';
  if (s.includes('principal_signature')) return 'signature';
  if (s.includes('id_card_footer')) return 'footer_bg';
  if (s.includes('/logo') || (s.includes('logo_') && !s.includes('id_card'))) return 'logo';
  return 'other';
}

export function resolveSchoolAssets(school, schoolId, cacheKey = '') {
  const url = (path) => schoolAssetDisplayUrl(path, schoolId, cacheKey || assetCacheToken(path, school, cacheKey));

  const pick = (kind) => {
    const raw = {
      signature: school?.principal_signature,
      footer_bg: school?.id_card_footer_bg,
      logo: school?.logo,
    }[kind];
    const direct = normalizeSchoolAssetPath(raw, schoolId) || raw;
    if (direct && pathKind(direct) === kind) return direct;
    for (const v of Object.values(school || {})) {
      if (typeof v !== 'string') continue;
      const candidate = normalizeSchoolAssetPath(v, schoolId) || v;
      if (pathKind(candidate) === kind) return candidate;
    }
    return null;
  };

  const logoPath = pick('logo');
  return {
    logoUrl: url(logoPath),
    principalSignatureUrl: url(pick('signature')),
    footerBgUrl: url(pick('footer_bg')),
  };
}

/** Merge live display URLs over server-resolved paths (blob or cache-busted). */
export function mergeCardAssetUrls(resolved, overrides = {}) {
  const pick = (key) => {
    const v = overrides[key];
    return v && String(v).trim() ? v : resolved[key] || '';
  };
  return {
    logoUrl: pick('logoUrl'),
    principalSignatureUrl: pick('principalSignatureUrl'),
    footerBgUrl: pick('footerBgUrl'),
    photoUrl: pick('photoUrl'),
  };
}
